<template>
           <TabHeader  />    
      <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
         
     <v-card-text>
      <v-container style="text-align: right;color:#0a42da;font-weight: bold;">
    {{nomPatient}}
  </v-container>
    <v-container v-if="creation">
        <v-row>
            <v-col
          cols="6"
          sm="4"
        >
        <v-text-field   variant="outlined"  v-model="data.datePrise" type="datetime-local" label="Date Observation"></v-text-field>

</v-col>
    </v-row>
<v-row>
    <v-textarea   variant="outlined"  label="Données" v-model="data.donnees" ></v-textarea>

</v-row>
<v-row>
    <v-textarea  variant="outlined" label="Action" v-model="data.action" ></v-textarea>

</v-row>
<v-row>
    <v-textarea variant="outlined"   label="Résultat" v-model="data.resultat" ></v-textarea>

</v-row>
<v-row justify="center">
    <v-btn @click="ajouter()"  color="blue-darken-4"
         class="text-none ms-4 text-white" >Valider</v-btn>
    <v-btn @click="creation=false" route to=""  color="red-darken-4"
         class="text-none ms-4 text-white">Annuler</v-btn>

</v-row>
</v-container>
<v-container v-if="!creation">
    <v-row>
<v-btn @click="create()"  
color="#0a42da"
class="text-none ms-1 text-white" ><v-icon
        class="me-2"
      >
      mdi-plus</v-icon>Ajouter une observation</v-btn>
</v-row>
<v-row>
<v-data-table
style="border-color: #0a42da;border-style: solid;border-width: 0.1px;"
:headers="headers"
:items="listdata"
no-data-text="Pas de données disponible"
items-per-page-text="Nombre d'elements par page"
v-model:sort-by="sortBy"
>
<template v-slot:[`item.datePrise`]="{ item }">       
        {{ $formatDate(item.datePrise) }}
      </template>  
<template v-slot:[`item.actions`]="{ item,index }">
    
      <v-btn flat route :to="'/observationView/'+getId()+'/'+item.id" @click="data=item;creation=true">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn  flat  @click="deleteItem(item,index)" >
      <v-icon
        size="small"
       
      >
        mdi-delete
      </v-icon>
      </v-btn>
    </template>
</v-data-table>
</v-row>
</v-container>
</v-card-text>
</v-card-item>
</v-card>
</template>
<script>
import http from '../../http.js'
import TabHeader from './TabHeader.vue'
export default {
  components: { TabHeader },
    data: () => ({
    sortBy:[{key:"datePrise",order:"desc"}],
    headers:[{"title":"Date","key":"datePrise"},{"title":"Données","key":"donnees"},{"title":"Action","key":"action"},{"title":"Resultat","key":"resultat"},{ title: 'Actions', key: 'actions', sortable: false }],
    creation:false,
    loading: false,
    nomPatient:null,
     data:{"datePrise": new Date().toLocaleString().substring(6,10)+"-"+new Date().toLocaleString().substring(3,5)+'-'+new Date().toLocaleString().substring(0,2)+""+new Date().toLocaleString().substring(10,19)},
     listdata:[]

    }),

    mounted(){
        this.list()
        this.date={}
       
        this.date.datePrise=new Date().toLocaleString().substring(6,10)+"-"+new Date().toLocaleString().substring(3,5)+'-'+new Date().toLocaleString().substring(0,2)+"T"+new Date().toLocaleString().substring(11,19);
        this.nomPatient= localStorage.getItem("nomPatient");
    },

    methods:{
        ajouter(){
          
            http.put('/api/addObservation/'+this.$route.params.id, JSON.stringify(this.data),{
        headers: {
            'Content-Type': 'application/json',
        }
    })
     .then(response => {
      console.log('File uploaded successfully:'+response.data);
      this.list()
      this.creation =false
      this.data={}

     })
    .catch(error => {
      alert(error)
      console.error('Error uploading file:', error);
  })
        },
    list(){
     
        http.get('/api/getObservation/'+this.$route.params.id).then(res=>{this.listdata=res.data;})
    },
    getId(){
            return this.$route.params.id;
        }
      ,          isAdmin(){
            let user =JSON.parse(localStorage.getItem("user"));
           return  user.profil==='admin';
        },

    create(){
      this.creation=true;
      this.data={}
      this.data.datePrise=new Date().toLocaleString().substring(6,10)+"-"+new Date().toLocaleString().substring(3,5)+'-'+new Date().toLocaleString().substring(0,2)+"T"+new Date().toLocaleString().substring(11,19);
    },
  
   async deleteItem(item,index){      
  
          if(confirm('Etes vous sur de la suppresion de cet observation ?')){
           await http.delete("/api/observation/"+this.getId()+"/"+item.id)
            this.listdata.splice(index, 1);
            
      }

    }
  }
}


</script>